export interface Author {
  id: string
  name: string
  /** Short credential line shown beside the name. */
  role: string
  bio: string
  image: string
}

export const authors: Author[] = [
  {
    id: 'dana-whitfield',
    name: 'Dana Whitfield, M.Ed.',
    role: 'Senior Education Editor',
    bio: 'Dana spent twelve years as an academic advisor for adult learners before joining FindOnlineColleges. She writes about accreditation, transfer credit, and what it really takes to finish a degree while working.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9b4e9774-a3a9-43b7-9732-c790c838c362.jpg',
  },
  {
    id: 'marcus-hale',
    name: 'Marcus Hale, MBA',
    role: 'Business & Careers Writer',
    bio: 'Marcus earned his MBA online while managing a logistics team. He covers business, criminal justice, and career-change programs, with a focus on cost, return, and employer recognition.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/302ac84f-9eae-41e5-91c5-317bd6af5b85.jpg',
  },
  {
    id: 'priya-raman',
    name: 'Priya Raman, BSN, RN',
    role: 'Healthcare Education Writer',
    bio: 'Priya is a registered nurse who completed her BSN through an online RN-to-BSN program. She writes about nursing and allied health pathways, clinical requirements, and licensure.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/870d241f-966e-4627-9677-dc4e23e855a4.jpg',
  },
]

export function getAuthorById(id: string | undefined): Author | undefined {
  if (!id) return undefined
  return authors.find((author) => author.id === id)
}
